import { API_ROOT } from 'environment';

angular.module('app.resources').factory('AccountStaticRtmp', ($q, $resource) =>
    $resource(`${API_ROOT}/accounts/:account_id/static_rtmps/:id`, { id: '@id', account_id: '@account_id' })
);


// WEBPACK FOOTER //
// ./resources/account_static_rtmp.js